import * as React from "react";
const SvgFiBrandsYandex = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M10.096 24v-2.417c0-3.281-.381-4.904-1.697-7.735L1.993 0h4.432l5.436 11.845c1.593 3.453 2.285 5.249 2.285 9.22V24zM12.693 11.603 17.748 0h4.259l-5.125 11.603z"
    />
  </svg>
);
export default SvgFiBrandsYandex;
